export const PASSKEY_APP_CLIENT_ID = 'app';

export const isPasskeyAppClient = (clientId: Nullable<string>): boolean => clientId?.trim() === PASSKEY_APP_CLIENT_ID;
